import React from "react";
import { useNavigate } from "react-router-dom";
import GetStartedTemplateBanner from "../../components/features/GetStartedTemplateBanner";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import { ROUTE_TEMPLATES_CREATE } from "../../constants/routes";
import { useAppSelector } from "../../redux/hooks";
import { useGetAllArticlesQuery } from "../../redux/services/article";
import { RootState } from "../../redux/store";

const TemplateCreateRedirect = () => {
  const navigate = useNavigate();
  const selectedAccount = useAppSelector(
    (state: RootState) => state.user.selectedAccount
  );
  const accountId = selectedAccount?.accountId ?? null;

  const {
    data: articles,
    isSuccess,
    isFetching,
  } = useGetAllArticlesQuery(
    {
      accountId,
      offset: 0,
      limit: 1,
      includeTotalCount: true,
    },
    { skip: !accountId, refetchOnMountOrArgChange: true }
  );

  if (isFetching) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <LoadingSpinner size="32px" />
      </div>
    );
  }

  // Conditional redirect based on total_count
  if (isSuccess && articles?.totalCount > 0) {
    navigate(ROUTE_TEMPLATES_CREATE);
    return null; // Prevent rendering ArticleCreateHero after redirect
  }

  return <GetStartedTemplateBanner />;
};

export default TemplateCreateRedirect;
